// /home/labdoo/zitech-nexus/frontend/src/pages/TrainingDetail.tsx
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { userTrainingAPI } from '../services/api';
import './TrainingDetail.css';

// SVG Icons
const Icons = {
  Back: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  ),
  Video: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="2.18" />
      <line x1="8" y1="2" x2="8" y2="22" />
      <line x1="16" y1="2" x2="16" y2="22" />
      <line x1="2" y1="8" x2="22" y2="8" />
      <line x1="2" y1="16" x2="22" y2="16" />
    </svg>
  ),
  Text: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7V4h16v3" />
      <line x1="9" y1="20" x2="15" y2="20" />
      <line x1="12" y1="4" x2="12" y2="20" />
    </svg>
  ),
  Quiz: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" />
      <path d="M2 17L12 22L22 17" />
      <path d="M2 12L12 17L22 12" />
    </svg>
  ),
  Assignment: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="td-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  Clock: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  StatusDot: () => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor">
      <circle cx="4" cy="4" r="4" />
    </svg>
  ),
  ChevronRight: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  File: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  ),
  Download: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 17L12 21L20 17" />
      <path d="M12 3V15M12 15L8 11M12 15L16 11" />
    </svg>
  ),
  Empty: () => (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" />
      <path d="M2 17L12 22L22 17" />
      <path d="M2 12L12 17L22 12" />
      <line x1="12" y1="12" x2="12" y2="7" />
    </svg>
  ),
  Error: () => (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
};

const TrainingDetail: React.FC = () => {
  const { enrollmentId } = useParams<{ enrollmentId: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [enrollment, setEnrollment] = useState<any>(null);
  const [selectedModule, setSelectedModule] = useState<any>(null);
  const [selectedContent, setSelectedContent] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [markingComplete, setMarkingComplete] = useState(false);

  // Wrap fetchEnrollment in useCallback to prevent unnecessary re-renders
  const fetchEnrollment = useCallback(async () => {
    if (!enrollmentId) {
      navigate('/dashboard/trainings');
      return;
    }
    
    try {
      setLoading(true);
      setError(null);
      const response = await userTrainingAPI.getEnrollment(parseInt(enrollmentId));
      setEnrollment(response.data);
      
      if (response.data.progress_modules && response.data.progress_modules.length > 0) {
        setSelectedModule(response.data.progress_modules[0]);
        if (response.data.progress_modules[0].contents?.length > 0) {
          setSelectedContent(response.data.progress_modules[0].contents[0]);
        }
      }
    } catch (error: any) {
      console.error('Error fetching enrollment:', error);
      setError(error.response?.data?.detail || error.message || 'Failed to load training');
    } finally {
      setLoading(false);
    }
  }, [enrollmentId, navigate]);

  useEffect(() => {
    fetchEnrollment();
  }, [fetchEnrollment]);

  // Start training session when enrollment loads and hasn't been started
  useEffect(() => {
    const startTrainingSession = async () => {
      if (enrollmentId && enrollment && !enrollment.started_at) {
        try {
          console.log('Starting training session for enrollment:', enrollmentId);
          await userTrainingAPI.startTrainingSession(parseInt(enrollmentId));
          // Refresh enrollment data to get updated started_at
          await fetchEnrollment();
        } catch (error) {
          console.error('Error starting training session:', error);
        }
      }
    };
    
    if (enrollment && !enrollment.started_at) {
      startTrainingSession();
    }
  }, [enrollment, enrollmentId, fetchEnrollment]);

  const markContentAsComplete = async () => {
    if (!selectedContent || !enrollment) return;
    
    setMarkingComplete(true);
    try {
      const timeSpentSeconds = selectedContent.duration_minutes * 60;
      
      await userTrainingAPI.completeContentProgress(
        selectedContent.id,
        enrollment.id,
        timeSpentSeconds
      );
      
      await fetchEnrollment();
      alert('Content marked as complete! Progress updated.');
    } catch (error) {
      console.error('Error marking content complete:', error);
      alert('Failed to mark content as complete');
    } finally {
      setMarkingComplete(false);
    }
  };

  const getContentIcon = (type: string) => {
    switch(type) {
      case 'video': return <Icons.Video />;
      case 'text': return <Icons.Text />;
      case 'quiz': return <Icons.Quiz />;
      case 'assignment': return <Icons.Assignment />;
      default: return <Icons.File />;
    }
  };

  const getContentLabel = (type: string) => {
    switch(type) {
      case 'video': return 'Video Lesson';
      case 'text': return 'Text Lesson';
      case 'quiz': return 'Quiz';
      case 'assignment': return 'Assignment';
      default: return 'Content';
    }
  };

  const getContentColor = (type: string) => {
    switch(type) {
      case 'video': return '#0ea5e9';
      case 'text': return '#10b981';
      case 'quiz': return '#8b5cf6';
      case 'assignment': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  const getContentBackground = (type: string) => {
    switch(type) {
      case 'video': return '#dbeafe';
      case 'text': return '#d1fae5';
      case 'quiz': return '#ede9fe';
      case 'assignment': return '#fef3c7';
      default: return '#f3f4f6';
    }
  };

  const isContentCompleted = () => {
    if (!selectedContent || !enrollment?.progress_details) return false;
    return enrollment.progress_details.some(
      (progress: any) => progress.content === selectedContent.id && progress.is_completed
    );
  };

  const getDifficultyColor = (difficulty: string) => {
    switch(difficulty) {
      case 'beginner': return '#10b981';
      case 'intermediate': return '#f59e0b';
      case 'advanced': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getDifficultyBackground = (difficulty: string) => {
    switch(difficulty) {
      case 'beginner': return '#d1fae5';
      case 'intermediate': return '#fef3c7';
      case 'advanced': return '#fee2e2';
      default: return '#f3f4f6';
    }
  };

  if (loading) {
    return (
      <div className="td-loading-container">
        <div className="td-spinner">
          <Icons.Spinner />
        </div>
        <p className="td-loading-text">Loading training content...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="td-error-container">
        <Icons.Error />
        <h2 className="td-error-title">Error Loading Training</h2>
        <p className="td-error-text">{error}</p>
        <button className="td-error-btn" onClick={() => navigate('/dashboard/trainings')}>
          <Icons.Back />
          Back to My Learning
        </button>
      </div>
    );
  }

  if (!enrollment) {
    return (
      <div className="td-error-container">
        <Icons.Empty />
        <h2 className="td-error-title">Training Not Found</h2>
        <p className="td-error-text">The training you're looking for doesn't exist or you don't have access.</p>
        <button className="td-error-btn" onClick={() => navigate('/dashboard/trainings')}>
          <Icons.Back />
          Back to My Learning
        </button>
      </div>
    );
  }

  return (
    <div className="td-container">
      {/* Header */}
      <div className="td-header">
        <button className="td-back-btn" onClick={() => navigate('/dashboard/trainings')}>
          <Icons.Back />
          Back to My Learning
        </button>
        <div className="td-header-content">
          <h1 className="td-title">{enrollment.technology} Training</h1>
          <div className="td-header-meta">
            <span className="td-meta-item">
              <Icons.Clock />
              {enrollment.progress_percentage || 0}% Complete
            </span>
            <span className="td-meta-divider">|</span>
            <span className="td-meta-item">
              <Icons.StatusDot />
              {enrollment.status === 'completed' ? 'Completed' : enrollment.status === 'in_progress' ? 'In Progress' : 'Not Started'}
            </span>
          </div>
        </div>
        <div className="td-overall-progress">
          <div className="td-progress-bar">
            <div 
              className="td-progress-fill"
              style={{ width: `${enrollment.progress_percentage || 0}%` }}
            />
          </div>
        </div>
      </div>

      {/* Content Wrapper */}
      <div className="td-content-wrapper">
        {/* Sidebar */}
        <div className="td-sidebar">
          <div className="td-sidebar-header">
            <h3 className="td-sidebar-title">Course Content</h3>
            <span className="td-sidebar-count">{enrollment.progress_modules?.length || 0} Modules</span>
          </div>
          <div className="td-modules-list">
            {enrollment.progress_modules && enrollment.progress_modules.length > 0 ? (
              enrollment.progress_modules.map((module: any, index: number) => (
                <div 
                  key={module.id}
                  className={`td-module-item ${selectedModule?.id === module.id ? 'td-module-active' : ''}`}
                  onClick={() => {
                    setSelectedModule(module);
                    setSelectedContent(module.contents?.[0]);
                  }}
                >
                  <div className="td-module-header">
                    <span className="td-module-number">{index + 1}</span>
                    <span className="td-module-title">{module.title}</span>
                    <Icons.ChevronRight />
                  </div>
                  <div className="td-module-meta">
                    <span className="td-module-duration">
                      <Icons.Clock />
                      {module.duration_hours} hours
                    </span>
                    <span 
                      className="td-module-difficulty"
                      style={{
                        background: getDifficultyBackground(module.difficulty),
                        color: getDifficultyColor(module.difficulty)
                      }}
                    >
                      {module.difficulty}
                    </span>
                    {module.contents && (
                      <span className="td-module-contents">
                        {module.contents.length} lessons
                      </span>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="td-no-modules">
                <p>No modules available for this technology yet.</p>
              </div>
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="td-main-content">
          {selectedModule && selectedContent ? (
            <div className="td-content-area">
              <div className="td-content-header">
                <div className="td-content-header-left">
                  <h2 className="td-content-title">{selectedContent.title}</h2>
                  <div className="td-content-tags">
                    <span 
                      className="td-content-type"
                      style={{
                        background: getContentBackground(selectedContent.content_type),
                        color: getContentColor(selectedContent.content_type)
                      }}
                    >
                      {getContentIcon(selectedContent.content_type)}
                      {getContentLabel(selectedContent.content_type)}
                    </span>
                    {selectedContent.duration_minutes && (
                      <span className="td-content-duration">
                        <Icons.Clock />
                        {selectedContent.duration_minutes} minutes
                      </span>
                    )}
                    {isContentCompleted() && (
                      <span className="td-content-completed">
                        <Icons.Check />
                        Completed
                      </span>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="td-content-body">
                {selectedContent.content_type === 'video' ? (
                  <div className="td-video-container">
                    <iframe
                      src={selectedContent.content}
                      title={selectedContent.title}
                      className="td-video-iframe"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                ) : selectedContent.content_type === 'quiz' ? (
                  <div className="td-quiz-container">
                    <div className="td-quiz-content" dangerouslySetInnerHTML={{ __html: selectedContent.content }} />
                  </div>
                ) : selectedContent.content_type === 'assignment' ? (
                  <div className="td-assignment-container">
                    <div className="td-assignment-content" dangerouslySetInnerHTML={{ __html: selectedContent.content }} />
                  </div>
                ) : (
                  <div className="td-text-content">
                    <div 
                      className="td-formatted-content"
                      dangerouslySetInnerHTML={{ __html: selectedContent.content.replace(/\n/g, '<br/>') }}
                    />
                  </div>
                )}
              </div>
              
              <div className="td-content-footer">
                <button 
                  className={`td-complete-btn ${isContentCompleted() ? 'td-completed' : ''}`}
                  onClick={markContentAsComplete}
                  disabled={markingComplete || isContentCompleted()}
                >
                  {markingComplete ? (
                    <>
                      <span className="td-spinner-small"></span>
                      Processing...
                    </>
                  ) : isContentCompleted() ? (
                    <>
                      <Icons.Check />
                      Completed
                    </>
                  ) : (
                    'Mark as Complete'
                  )}
                </button>
              </div>
            </div>
          ) : (
            <div className="td-no-content">
              <Icons.Empty />
              <p>Select a module from the sidebar to start learning</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrainingDetail;